'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _typeof2 = require('babel-runtime/helpers/typeof');

var _typeof3 = _interopRequireDefault(_typeof2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _redboxReact2 = require('redbox-react');

var _redboxReact3 = _interopRequireDefault(_redboxReact2);

var _react2 = require('react');

var _react3 = _interopRequireDefault(_react2);

var _reactTransformCatchErrors3 = require('react-transform-catch-errors');

var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);

var _dec, _dec2, _class, _class2, _temp;

var _Link = require('components/Link/Link');

var _Link2 = _interopRequireDefault(_Link);

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _ReviewItem = require('./ReviewItem.scss');

var _ReviewItem2 = _interopRequireDefault(_ReviewItem);

var _reactRedux = require('react-redux');

var _media = require('utils/media');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _components = {
  ReviewItem: {
    displayName: 'ReviewItem'
  }
};

var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
  filename: '/home/runner/work/redux-frontend/redux-frontend/src/components/Home/ReviewItem.js',
  components: _components,
  locals: [],
  imports: [_react3.default, _redboxReact3.default]
});

function _wrapComponent(id) {
  return function (Component) {
    return _reactTransformCatchErrors2(Component, id);
  };
}

var ReviewItem = _wrapComponent('ReviewItem')((_dec = (0, _reactRedux.connect)(function (state) {
  return {
    siteConfigs: state.info.siteConfigs
  };
}), _dec2 = (0, _reactCssModules2.default)(_ReviewItem2.default), _dec(_class = _dec2(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(ReviewItem, _Component);

  function ReviewItem(props) {
    (0, _classCallCheck3.default)(this, ReviewItem);

    var _this = (0, _possibleConstructorReturn3.default)(this, (ReviewItem.__proto__ || (0, _getPrototypeOf2.default)(ReviewItem)).call(this, props));

    _this.renderReview = _this.renderReview.bind(_this);

    if (!(typeof _this.renderReview === 'function')) {
      throw new TypeError('Value of "this.renderReview" violates contract.\n\nExpected:\n() => any\n\nGot:\n' + _inspect(_this.renderReview));
    }

    return _this;
  }

  (0, _createClass3.default)(ReviewItem, [{
    key: 'renderReview',
    value: function renderReview() {
      var review = this.props.review;

      var defaultImage = require('theme/images/default-img.png');
      return _react3.default.createElement(
        'div',
        { styleName: 'container' },
        _react3.default.createElement('div', { styleName: 'image', style: review.trip_id.cover_image ? (0, _media.path)(review.trip_id.cover_image, 'featureCover', true) : null }),
        _react3.default.createElement(
          'div',
          { styleName: 'detail' },
          _react3.default.createElement(
            'div',
            { styleName: 'profile-pic' },
            _react3.default.createElement('img', { alt: review.user_id && review.user_id.name && review.user_id.name.first + ' ' + review.user_id.name.last, src: review.user_id && review.user_id.avatar_image ? (0, _media.path)(review.user_id.avatar_image, 'profileAvatar') : defaultImage })
          ),
          _react3.default.createElement(
            'h3',
            { className: 'review-item-user-name', styleName: 'user-name' },
            review.user_id && review.user_id.name && review.user_id.name.first + ' ' + review.user_id.name.last
          ),
          _react3.default.createElement(
            'div',
            { styleName: 'desc-wrapper' },
            _react3.default.createElement('div', { styleName: 'open' }),
            _react3.default.createElement(
              'p',
              { styleName: 'review-content' },
              review.text
            ),
            _react3.default.createElement('div', { styleName: 'close' })
          )
        )
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          review = _props.review,
          siteConfigs = _props.siteConfigs;

      if (siteConfigs.disableFeaturedReviewLink) {
        return _react3.default.createElement(
          'a',
          { styleName: 'link', to: '/trip/' + review.trip_id.slug },
          this.renderReview()
        );
      }
      return _react3.default.createElement(
        _Link2.default,
        { styleName: 'link', to: '/trip/' + review.trip_id.slug },
        this.renderReview()
      );
    }
  }]);
  return ReviewItem;
}(_react2.Component), _class2.propTypes = {
  review: _react2.PropTypes.object,
  siteConfigs: _react2.PropTypes.object
}, _class2.defaultProps = {
  review: {}
}, _temp)) || _class) || _class));

exports.default = ReviewItem;

function _inspect(input, depth) {
  var maxDepth = 4;
  var maxKeys = 15;

  if (depth === undefined) {
    depth = 0;
  }

  depth += 1;

  if (input === null) {
    return 'null';
  } else if (input === undefined) {
    return 'void';
  } else if (typeof input === 'string' || typeof input === 'number' || typeof input === 'boolean') {
    return typeof input === 'undefined' ? 'undefined' : (0, _typeof3.default)(input);
  } else if (Array.isArray(input)) {
    if (input.length > 0) {
      if (depth > maxDepth) return '[...]';

      var first = _inspect(input[0], depth);

      if (input.every(function (item) {
        return _inspect(item, depth) === first;
      })) {
        return first.trim() + '[]';
      } else {
        return '[' + input.slice(0, maxKeys).map(function (item) {
          return _inspect(item, depth);
        }).join(', ') + (input.length >= maxKeys ? ', ...' : '') + ']';
      }
    } else {
      return 'Array';
    }
  } else {
    var keys = (0, _keys2.default)(input);

    if (!keys.length) {
      if (input.constructor && input.constructor.name && input.constructor.name !== 'Object') {
        return input.constructor.name;
      } else {
        return 'Object';
      }
    }

    if (depth > maxDepth) return '{...}';
    var indent = '  '.repeat(depth - 1);
    var entries = keys.slice(0, maxKeys).map(function (key) {
      return (/^([A-Z_$][A-Z0-9_$]*)$/i.test(key) ? key : (0, _stringify2.default)(key)) + ': ' + _inspect(input[key], depth) + ';';
    }).join('\n  ' + indent);

    if (keys.length >= maxKeys) {
      entries += '\n  ' + indent + '...';
    }

    if (input.constructor && input.constructor.name && input.constructor.name !== 'Object') {
      return input.constructor.name + ' {\n  ' + indent + entries + '\n' + indent + '}';
    } else {
      return '{\n  ' + indent + entries + '\n' + indent + '}';
    }
  }
}

module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Home/ReviewItem.js
// module id = 1534
// module chunks = 47